import { LocalStorageKeys } from '../enums/local-storage-keys';

export function getFromLocalStorage<T>(key: LocalStorageKeys, fallback: T) {
  let item;
  if (typeof window !== 'undefined') {
    item = localStorage.getItem(key);
  }
  let parsed;
  try {
    parsed = JSON.parse(item as string) as T;
  } catch (e) {
    return fallback;
  }
  return parsed ?? fallback;
}
